import { Injectable } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import Swal2 from 'sweetalert2';
import { RequestService } from '../request/request.service';

@Injectable({ providedIn: 'root' })
export class SocialAccountAuthService {
  constructor(private request: RequestService) {}

  async offerLogin(platform: string, endpoint: string, payload: any = {}): Promise<boolean> {
    const result = await Swal2.fire({
      title: `${platform} no está conectado`,
      text: `Necesitas autenticar tu cuenta de ${platform} para publicar. ¿Quieres iniciar sesión ahora?`,
      icon: 'info',
      position: 'top',
      toast: true,
      showCancelButton: true,
      confirmButtonText: `Conectar ${platform}`,
      cancelButtonText: 'Ahora no',
      confirmButtonColor: '#246bfd',
      cancelButtonColor: '#596275',
      color: '#ffffff',
      background: '#010f4e',
    });

    if (!result.isConfirmed) {
      return false;
    }

    return this.openLogin(platform, endpoint, payload);
  }

  async openLogin(platform: string, endpoint: string, payload: any = {}): Promise<boolean> {
    try {
      const response = await this.request.createRequestPost(endpoint, payload);
      const parsed = this.parseResponse(response);
      const loginUrl = typeof parsed === 'string' ? parsed : parsed?.url;

      if (!loginUrl) {
        throw new Error(`${platform} authentication URL was not returned.`);
      }

      if (Capacitor.getPlatform() === 'android') {
        window.open(loginUrl, '_blank', 'location=yes,toolbar=yes');
      } else {
        await Browser.open({ url: loginUrl });
      }
      return true;
    } catch (error) {
      console.error(`Unable to start ${platform} authentication:`, error);
      await Swal2.fire({
        title: `No pudimos conectar ${platform}`,
        text: 'Inténtalo nuevamente en unos momentos.',
        icon: 'error',
        position: 'top',
        toast: true,
        confirmButtonText: 'Entendido',
        color: '#ffffff',
        background: '#010f4e',
      });
      return false;
    }
  }

  private parseResponse(response: any): any {
    if (typeof response !== 'string') {
      return response;
    }
    const trimmed = response.trim();
    if (!trimmed.startsWith('{') && !trimmed.startsWith('[') && !trimmed.startsWith('"')) {
      return response;
    }
    try {
      return JSON.parse(trimmed);
    } catch {
      return response;
    }
  }
}
